import React from "react";

// Modal "Durum" sekmesi.
// NOT: Son başarılı istek / Bugünkü işlem / Hata oranı gibi metrikler için
// backend endpoint'i henüz yok. Gerçekten mevcut olan bağlantı durumu ve ortam
// (testMode) gösterilir; metrikler backend gelene kadar "—" ile placeholder.
const Row = ({ label, children }) => (
    <div
        className="d-flex align-items-center justify-content-between px-3 mb-2"
        style={{ backgroundColor: "#f4f6fb", borderRadius: 14, minHeight: 58 }}
    >
        <span style={{ color: "#5c6a86" }}>{label}</span>
        <span className="fw-semibold text-end" style={{ color: "#1f2937" }}>{children}</span>
    </div>
);

export default function IntegrationStatusPanel({ connected, testMode }) {
    return (
        <div>
            <Row label="Bağlantı durumu">
                <span className="d-inline-flex align-items-center gap-2" style={{ color: connected ? "#2f9e44" : "#8892a6" }}>
                    <span
                        className="rounded-circle"
                        style={{ width: 9, height: 9, backgroundColor: connected ? "#2f9e44" : "#c9ced8" }}
                    />
                    {connected ? "Aktif" : "Pasif"}
                </span>
            </Row>
            <Row label="Son başarılı istek"><span style={{ color: "#aab1c1" }}>—</span></Row>
            <Row label="Bugünkü işlem"><span style={{ color: "#aab1c1" }}>—</span></Row>
            <Row label="Hata oranı"><span style={{ color: "#aab1c1" }}>—</span></Row>
            <Row label="Ortam">{testMode ? "Test (Sandbox)" : "Canlı (Production)"}</Row>

            <p className="text-muted small mb-0 mt-2">
                <i className="bx bx-info-circle me-1" />
                Detaylı işlem metrikleri yakında bu ekranda görüntülenecektir.
            </p>
        </div>
    );
}
